
import React from 'react';
import { Image, Briefcase } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  type: 'portfolio' | 'experience';
  onAddClick: () => void;
}

const EmptyState = ({ type, onAddClick }: EmptyStateProps) => {
  const title = type === 'portfolio' ? 'No Portfolio Projects Yet' : 'No Experience Added Yet';
  const description = type === 'portfolio'
    ? 'Showcase your best work by adding portfolio projects that highlight your skills and achievements.'
    : 'Add your work experience to show your professional journey and expertise.';
  const buttonText = type === 'portfolio' ? 'Add First Project' : 'Add First Experience';
  const Icon = type === 'portfolio' ? Image : Briefcase;

  return (
    <div className="flex flex-col items-center justify-center p-8 border border-dashed rounded-lg text-center space-y-4 bg-muted/50">
      {type === 'portfolio' ? (
        <div className="bg-primary/10 p-4 rounded-full flex items-center justify-center">
          <img 
            src="/lovable-uploads/9e8df335-b81d-4efd-99b8-3e682345adcd.png" 
            alt="No portfolio projects" 
            className="h-20 w-20 object-contain"
            onError={(e) => {
              e.currentTarget.src = '/placeholder.svg';
            }}
          />
        </div>
      ) : (
        <div className="bg-primary/10 p-4 rounded-full flex items-center justify-center">
          <img 
            src="/lovable-uploads/667f98fb-a40d-47d7-8ff5-68eebb9bbd8b.png" 
            alt="No experience items" 
            className="h-20 w-20 object-contain"
            onError={(e) => {
              e.currentTarget.src = '/placeholder.svg';
            }}
          />
        </div>
      )}
      
      <h3 className="font-semibold text-lg">{title}</h3>
      <p className="text-muted-foreground max-w-sm">{description}</p>
      <Button 
        onClick={onAddClick} 
        variant="outline" 
        className="mt-2"
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default EmptyState;
